import { useEffect, useState } from "react";
import api from "../../api/api";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function AdminHotelRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await api.get("/hotel/requests");
      setRequests(res.data);
    } catch (err) {
      console.error("Error fetching hotel requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Hotel Booking Requests</h1>

      {loading ? (
        <div className="animate-pulse text-gray-500">Loading requests...</div>
      ) : (
        <div className="bg-white shadow-lg rounded-xl overflow-hidden border">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 border-b">
              <tr className="text-left text-gray-700">
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Phone</th>
                <th className="p-3">Destination</th>
                <th className="p-3">Check-in</th>
                <th className="p-3">Check-out</th>
                <th className="p-3">Guests</th>
                <th className="p-3 text-center">Details</th>
              </tr>
            </thead>

            <tbody>
              {requests.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-8 text-gray-500">
                    No hotel booking requests found.
                  </td>
                </tr>
              ) : (
                requests.map((req) => {
                  const isOpen = expandedRow === req.id;

                  return (
                    <>
                      <tr
                        key={req.id}
                        className="border-b hover:bg-gray-50 transition cursor-pointer"
                        onClick={() =>
                          setExpandedRow((prev) => (prev === req.id ? null : req.id))
                        }
                      >
                        <td className="p-3">{req.full_name}</td>
                        <td className="p-3">{req.email}</td>
                        <td className="p-3">{req.phone}</td>
                        <td className="p-3">{req.destination}</td>
                        <td className="p-3">{formatDate(req.check_in)}</td>
                        <td className="p-3">{formatDate(req.check_out)}</td>
                        <td className="p-3">{req.guests}</td>
                        <td className="p-3 text-center">
                          {isOpen ? (
                            <ChevronUp className="w-5 h-5 mx-auto" />
                          ) : (
                            <ChevronDown className="w-5 h-5 mx-auto" />
                          )}
                        </td>
                      </tr>

                      {/* Expandable Notes Row */}
                      {isOpen && (
                        <tr className="bg-gray-50 border-b">
                          <td colSpan="8" className="p-4">
                            <div className="p-4 bg-white rounded-lg shadow-sm border">
                              <h3 className="font-semibold text-gray-700 mb-1">
                                Notes / Additional Request:
                              </h3>
                              <p className="text-gray-600">
                                {req.notes ? req.notes : "No notes provided."}
                              </p>

                              <div className="mt-4 text-sm text-gray-500">
                                Request date:{" "}
                                {new Date(req.created_at).toLocaleString()}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
